import type { Cents } from './Currency';

export const LINK_NEW_DEPOSIT_ACCOUNT: DepositAccount = {
    id: 'link-new-account',
    isExternal: false,
    accountNumberMasked: '',
    accountType: '',
    bankName: '',
    nickname: 'Link a new account',
    accountNumberMaskedIsTokenized: false,
    nonTokenizedAccountNumberMasked: undefined,
    verified: true,
};

export enum RecurringTransferFrequency {
    WEEKLY = 'weekly',
    FORTNIGHTLY = 'fortnightly',
    MONTHLY = 'monthly',
}

export const RECURRING_TRANSFER_FREQUENCY_DESCRIPTION_MAP: Record<
    RecurringTransferFrequency,
    string
> = {
    [RecurringTransferFrequency.WEEKLY]: 'Weekly',
    [RecurringTransferFrequency.FORTNIGHTLY]: 'Every 2 weeks',
    [RecurringTransferFrequency.MONTHLY]: 'Monthly',
};

export enum RecurringTransferEndType {
    NEVER = 'never',
    ON = 'on',
    AFTER = 'after',
}

export class DepositAccount {
    id!: string;
    isExternal!: boolean;
    accountNumberMasked!: string;
    accountNumber?: string;
    accountType!: string;
    bankName!: string;
    nickname!: string;
    availableBalance?: Cents; // Only populated for internal accounts
    imgBase64?: string;
    logo?: string;
    icon?: string;
    color?: string;
    accountNumberMaskedIsTokenized!: boolean;
    nonTokenizedAccountNumberMasked?: string;
    verified?: boolean;
}

export class TransferRequest {
    amount!: Cents;
    toDepositAccount!: DepositAccount;
    fromDepositAccount!: DepositAccount;
    recurring?: RecurringTransferSetupDetails;
    applyIncomeSplit?: boolean;
}

export class RecurringTransferSetupDetails {
    description?: string;
    frequency?: RecurringTransferFrequency;
    start?: Date;
    end?: {
        type?: RecurringTransferEndType;
        date?: Date;
        count?: number;
    };
}

export class RecurringDetailsRequestDTO {
    recurringDescription!: string;
    recurringStartDate!: string; // ISO date format
    recurringFrequency!: RecurringTransferFrequency;
    recurringEndType!: RecurringTransferEndType;
    recurringEndDate?: string; // ISO date format, Inclusive
    recurringCount?: number | null;
    /** 24-hour HH:MM:SS execution time in ET. Omitted by older clients → backend defaults to 11:00:00. */
    executionTime?: string;
}

export interface PaymentDate {
    execution_date: string;
    scheduled_date: string;
}
